import { useNavigate } from "react-router-dom";
import { useFilterSync } from "./use-filter-sync";

interface UseFilterBack {
    onFilterBack: (pathname: string) => void;
}

export function useFilterBack(): UseFilterBack {
    const { refetchFilters } = useFilterSync();
    const navigate = useNavigate();

    const onFilterBack = (pathname: string): void => {
        refetchFilters();
        navigate(pathname);
    };

    return {
        onFilterBack,
    };
}
